import { api } from '@/redux/api/api';
import { QueryHandler } from '@/redux/types/query-handler';
import { replaceItemRecipe } from '@/redux/utils/replace-item-recipe';
import { Organisation } from '@/types/organisation';
import { dispatchOptimisticPatchCreateOrganisation } from './dispatch-optimistic-patch';
import { CreateOrganisationQueryArg } from '../types/query-arg';

export const handleResultCreateOrganisation: QueryHandler<
  CreateOrganisationQueryArg,
  Organisation
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch, optimisticOrg } = dispatchOptimisticPatchCreateOrganisation(
    queryArg,
    {
      dispatch,
      getState,
    },
  );

  try {
    const { data: org } = await queryFulfilled;
    dispatch(
      api.util.updateQueryData(
        'getOrganisations',
        undefined,
        replaceItemRecipe(
          'optimisticId' as keyof Organisation,
          optimisticOrg.optimisticId,
          org,
        ),
      ),
    );
  } catch (err) {
    patch.undo();
    throw err;
  }
};
